import { useCallback, useMemo } from 'react';
import * as t from 'ts-schema';
import { registerQuery, useQuery } from 'data-fetching-client';
import { collectionSchema } from 'marketplace-ui-common/collections/types/Collection';
import { getDataFetchingClientRequestState } from 'marketplace-ui-common/dataFetchingClient/utils/getDataFetchingClientRequestState';
import { fetchPublishedCollections } from '../../clients/qualityClient';
const publishedCollectionsResponseSchema = t.object({
  collections: t.array(collectionSchema)
});

function getAppCollections({
  isAdminPreview = false
}) {
  return fetchPublishedCollections(isAdminPreview).then(resp => t.assert(publishedCollectionsResponseSchema, resp));
}

const GET_PUBLISHED_COLLECTIONS = registerQuery({
  fieldName: 'collections',
  args: ['isAdminPreview'],
  fetcher: getAppCollections
});
export function usePublishedAppCollections(isAdminPreview = false) {
  const {
    data,
    error,
    loading,
    previousData
  } = useQuery(GET_PUBLISHED_COLLECTIONS, {
    variables: {
      isAdminPreview
    }
  });
  const requestState = getDataFetchingClientRequestState(error, loading);
  const publishedAppCollections = useMemo(() => {
    const collectionsData = data || previousData;

    if (!collectionsData) {
      return [];
    } else {
      return collectionsData.collections.collections;
    }
  }, [data, previousData]);
  const getDisplayedCollections = useCallback(() => {
    const displayedCollections = publishedAppCollections.filter(collection => collection.publishedListing ? collection.publishedListing.displayed : false);
    const sortedDisplayedCollections = displayedCollections.sort((a, b) => b.createdAt - a.createdAt);
    return sortedDisplayedCollections;
  }, [publishedAppCollections]);
  return {
    data: publishedAppCollections,
    getDisplayedCollections,
    requestState
  };
}